<div class="spin-wrapper">
    <nz-spin nzSimple nzSize="large"></nz-spin>
</div>